var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3121 12.6396L10.0871 9.41461C10.0296 9.35711 9.95461 9.32711 9.87461 9.32711H9.61711C10.4746 8.39961 10.9996 7.16211 10.9996 5.79961C10.9996 2.92711 8.67211 0.599609 5.79961 0.599609C2.92711 0.599609 0.599609 2.92711 0.599609 5.79961C0.599609 8.67211 2.92711 10.9996 5.79961 10.9996C7.16211 10.9996 8.39961 10.4746 9.32711 9.61961V9.87461C9.32711 9.95461 9.35961 10.0296 9.41461 10.0871L12.6396 13.3121C12.7571 13.4296 12.9471 13.4296 13.0646 13.3121L13.3121 13.0646C13.4296 12.9471 13.4296 12.7571 13.3121 12.6396ZM5.79961 10.1996C3.36711 10.1996 1.39961 8.23211 1.39961 5.79961C1.39961 3.36711 3.36711 1.39961 5.79961 1.39961C8.23211 1.39961 10.1996 3.36711 10.1996 5.79961C10.1996 8.23211 8.23211 10.1996 5.79961 10.1996Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c1c86bdeb50323327743a46f43f19e95.svg";
export { ForwardRef as ReactComponent };